import React from 'react';
const renderBold = (text, children) => {
  return text.bold ? /*#__PURE__*/React.createElement("strong", null, children) : children;
};
const renderItalic = (text, children) => {
  return text.italic ? /*#__PURE__*/React.createElement("em", null, children) : children;
};
const renderUnderline = (text, children) => {
  return text.underline ? /*#__PURE__*/React.createElement("u", null, children) : children;
};
const renderStrikethrough = (text, children) => {
  return text.strikethrough ? /*#__PURE__*/React.createElement("s", null, children) : children;
};
export const Leaf = _ref => {
  let {
    attributes,
    leaf,
    children
  } = _ref;
  const elementToRender = renderStrikethrough(leaf, renderUnderline(leaf, renderItalic(leaf, renderBold(leaf, children))));
  return /*#__PURE__*/React.createElement("span", attributes, elementToRender);
};